
import React from 'react';
import { Link } from 'react-router-dom';
import { Progress, Tooltip } from 'antd';


import arrow from "../../../../assets/svg/arrow-right.svg"
import './eachUser.scss'

export default (props) =>{
    // const { history } = this.props

    return (
        <div className="report-list">
            <ul>
                <li>{props.name}</li>
                <li>{props.storage}</li>
                <li>{props.source}</li>
                <li>{props.activeDate}</li>
                {/* <li>{props.signupDate}</li> */}
                <li>{props.status}</li>
                <li>
                    {/* <Link to="/usageDetail"> */}
                        <Tooltip title="Detail">
                            <img
                                className="arrow-icon"
                                src={arrow}
                                alt=""
                                

                                // onClick={e => {
                                // e.stopPropagation()
                                // history.push(`/addProvider`)
                                // }}
                            />
                        </Tooltip>
                    {/* </Link> */}
                </li>
            </ul>
        </div>
    )
}

